import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import AdminLayout from '../../layouts/AdminLayout';

import Main from './main';

function index({ match }) {
  return (
    <AdminLayout>
      <Switch>
        <Route exact path={`${match.url}`} component={Main} />
      </Switch>
    </AdminLayout>
  );
}

const mapStateToProps = (state) => ({
  //
});

export default connect(mapStateToProps, {})(index);
